export const environment = {
  production: true,
  endpoint: ''
};
